import { render, staticRenderFns } from "./freshHome.vue?vue&type=template&id=44ccefb8&scoped=true&"
import script from "./freshHome.js?vue&type=script&lang=js&"
export * from "./freshHome.js?vue&type=script&lang=js&"
import style0 from "./freshHome.vue?vue&type=style&index=0&id=44ccefb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ccefb8",
  null
  
)

export default component.exports